import type { PermissionType } from '../const';
import type { IGetPermission } from '../type';
import { useUserStore } from '@stores/user';
import { useMemo } from 'react';
import { userPermissionsManager } from './userPermissionsManager';

/**
 * 获取当前网站的权限
 * @param right 权益类型
 * @returns 权益信息
 */
export function getPermission(right: PermissionType): IGetPermission {
  const { getFinalPermissionList } = userPermissionsManager();
  return getFinalPermissionList(right);
}

/**
 * 是否有某个权益
 * @param permission 权益类型
 * @returns 权益信息 { hasPermission: boolean, quantity: number }
 */
export default function useHasPermission(permission: PermissionType): IGetPermission {
  const userPermissionList = useUserStore(state => state.userPermissionList);

  return useMemo(() => {
    return getPermission(permission);
  }, [userPermissionList, permission]);
}
